/**
 * Quiz category display map — mirrors `backend/quiz_engine.CATEGORY_DISPLAY`.
 * Keep both in sync when adding a new category.
 */
export const QUIZ_CATEGORY_DISPLAY = {
  career_year:        { name: "Transfer Year",  icon: "🗓️", accent: "#4ADE80" },
  career_club:        { name: "Club Career",    icon: "🏟️", accent: "#60A5FA" },
  teammate_at:        { name: "Teammates",      icon: "🤝", accent: "#F472B6" },
  player_nationality: { name: "Nationality",    icon: "🌍", accent: "#FBBF24" },
  player_position:    { name: "Position",       icon: "⚽", accent: "#A78BFA" },
  first_club:         { name: "First Club",     icon: "🌱", accent: "#34D399" },
  seasons_at_club:    { name: "Years at Club",  icon: "📅", accent: "#FB7185" },
};

export function quizCategoryDisplay(key) {
  return QUIZ_CATEGORY_DISPLAY[key] || { name: key, icon: "❓", accent: "#9CA3AF" };
}
